/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { FcmService } from '@shared/services/fcm.service';
import { InAppBrowser } from '@capgo/inappbrowser';
import { HttpClient } from '@angular/common/http';
import { LocationService } from '@shared/services/location.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { Preferences } from '@capacitor/preferences';
import { Subscription } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-referral-confirmation',
  templateUrl: './referral-confirmation.page.html',
  styleUrls: ['./referral-confirmation.page.scss'],
  providers: [LocationService, UserService, FcmService, UtilService]
})
export class ReferralConfirmationPage implements OnInit {

  // private unregisterFunction: Function|any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public otherUserData: any;
  private isIos: boolean = false;
  private isNative: boolean = true;
  private hasReloaded = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public myImageFB: any;
  public referralUserId: string = "";
  public imageUser: string = "";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public backButton: Subscription|any;
  constructor(public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private fcm: FcmService,
    public platform: Platform,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public locationSvc: LocationService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    public userService: UserService,
    public toastCtrl: ToastController,
    public util: UtilService) {

      this.util.initTranslate();
    platform.ready().then(() => {

      // this.unregisterFunction = this.platform.backButton.subscribe(() => {
      //   console.log('Handler was called!');
      //   this.closeReferral();
      // }).unsubscribe;
      //this.isIos = platform.is('ios');
      this.isIos = !platform.is('android');
      this.isNative = this.util.isNative();

      console.log('this.isIos:' + this.isIos);
      console.log('this.isNative:' + this.isNative);
      console.log('ipad:' + platform.is('ipad'));

      console.log('_platforms:' + platform.platforms());


      console.log('this.soulService.loggedOut:' + UserService.loggedOut);

      if (!UserService.loggedOut) {

        Preferences.get({key:'USER_DATA'}).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          this.userData = val;
        });
        

      }
    });
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        console.log('Handler was called!');
        this.closeReferral();
      });
    }
  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }

  async ionViewDidEnter() {

    Preferences.get({key:'USER_DATA'}).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      console.log('login ionViewDidEnter userdata: ' + val);
      if (val != null) {
        this.userData = val;     
        this.getImage()
      }
    });


  }

  getImage() {
    const picId =
      this.userData?.picture0?.$oid ||
      this.userData?.picture1?.$oid ||
      this.userData?.picture2?.$oid ||
      this.userData?.firstPic?.$oid;
    if (picId) {
      this.userData.firstPic = this.userService.getImageURL(picId);
      return;
    }
    if (typeof this.userData?.firstPic === 'string' && this.userData.firstPic.startsWith('http')) {
      return;
    }
    this.userData.firstPic = '';
  }
  downloadApp() {
    const campaign = this.userData?.referralUserId || '';
    const url = environment.adjustDownloadLink + (campaign ? '?campaign=' + campaign : '');
    if (Capacitor.isNativePlatform()) {
      InAppBrowser.open({ url: url });
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  public closeReferral() {
    // this.unregisterFunction();
    const contentElement = document.getElementById("contentDiv");
    if (contentElement == undefined || contentElement == null) {
      return;
      // This should not happen anymore now that we call the unregisterFunction. Keeping it here just in case.
      // In the future, we may register the registerBackButtonAction method from app.component and deal with view.id == ChatPage or other pages
    }
    contentElement.classList.add('animation');
    const newUrl = new URL(location.href);
    newUrl.searchParams.delete('referralUserId');
    window.history.replaceState({}, document.title, newUrl.href)
    this.modalCtrl.dismiss(null);

  }

}
